window.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.product-description-benefits-button');
    const tabs = document.querySelectorAll('.product-description-benefits-tab');
    
    setTimeout(() => {
        buttons.forEach((button, i, allButtons) => {
            button.addEventListener('click', (event) => {
                const buttonTab = button.dataset.tab;
                [...allButtons].forEach(b => b.classList.remove('active-description-benefits-button'));
                button.classList.add('active-description-benefits-button');
                tabs.forEach(tab => {
                    if(tab.dataset.tab === buttonTab) {
                        tab.classList.add('active-description-benefits-tab');
                        return;
                    }
                    tab.classList.remove('active-description-benefits-tab');
                })
            })
        })
    })
});
